import { format } from "date-fns";

/* O texto do tooltip do ✓ de presença confirmada.
 *
 * Partilhado pelas duas listas da secretária — a da agenda normal e a da agenda
 * de tratamentos — porque é a mesma frase, e duas cópias divergiriam na
 * primeira alteração.
 *
 * ─── PORQUE O «QUEM» PODE FALTAR ────────────────────────────────────────────
 *
 * Quando é a secretária a confirmar, `user` vem populado com o nome. Quando for
 * o próprio cliente — pelo link do SMS, ou pelo portal quando existir — não há
 * utilizador nosso a quem atribuir, e `user` fica nulo. Nesse caso a frase diz
 * que foi o cliente, em vez de mostrar um "por undefined". */
const COMO_CHEGOU = {
  secretaria: "pela secretária",
  sms: "pelo cliente, por SMS",
  whatsapp: "pelo cliente, por WhatsApp",
  portal: "pelo cliente, no portal",
};

export const textoConfirmacao = (confirmacao) => {
  if (!confirmacao?.data) return "";

  const quando = format(new Date(confirmacao.data), "dd/MM 'às' HH:mm");
  const nome = confirmacao.user?.name;
  const origem = COMO_CHEGOU[confirmacao.via];

  if (nome) return `Confirmado por ${nome} em ${quando}`;
  if (origem) return `Confirmado ${origem} em ${quando}`;
  return `Confirmado em ${quando}`;
};

/* ─── A CONFIRMAÇÃO É SOBRE O FUTURO ────────────────────────────────────────
 *
 * Só se confirma presença de um dia que ainda não chegou. No próprio dia já
 * não se pergunta «vem?» — a pessoa vem ou não vem, e quem está ao balcão
 * marca «Chegou» ou «Faltou». Um botão de confirmar ao lado desses dois dizia
 * três coisas sobre o mesmo momento.
 *
 * A data vem como `dd-MM-yyyy` — do seletor da lista ou, quando o dia foi
 * escolhido à mão, do `diaEmVista` aqui em baixo. É o formato em que todo este
 * ecrã a trata. */
export const ehDeDiaFuturo = (dataSelecionada) => {
  if (!dataSelecionada) return false;
  const [dia, mes, ano] = String(dataSelecionada).split("-").map(Number);
  if (!dia || !mes || !ano) return false;

  const diaDaLista = new Date(ano, mes - 1, dia);
  diaDaLista.setHours(0, 0, 0, 0);

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  return diaDaLista > hoje;
};

/* ─── «ESCOLHER DATA» NÃO É UMA DATA ────────────────────────────────────────
 *
 * O seletor da lista tem quatro opções. Ontem, Hoje e Amanhã já valem
 * `dd-MM-yyyy`; «Escolher Data» vale a palavra `escolher-data`, e o dia
 * verdadeiro fica no calendário ao lado, noutro estado.
 *
 * Quem lesse só o seletor partia a palavra em números, dava `NaN`, e o
 * `ehDeDiaFuturo` respondia «não». Resultado: escolher amanhã na lista
 * mostrava o botão de confirmar, escolher o MESMO amanhã no calendário
 * escondia-o.
 *
 * Devolve `null` enquanto o calendário está a meio de ser escrito — uma data
 * inválida não é um dia futuro, e o botão fica de fora até o dia estar feito.
 */
export const DIA_A_ESCOLHA = "escolher-data";

export const diaEmVista = (dataSelecionada, dataDoCalendario) => {
  if (dataSelecionada !== DIA_A_ESCOLHA) return dataSelecionada;

  const dia = new Date(dataDoCalendario);
  if (!dataDoCalendario || isNaN(dia.getTime())) return null;

  return format(dia, "dd-MM-yyyy");
};
